import * as httpx from "httpx"
import { CancellablePromise } from "real-cancellable-promise"

import {
	ProductTaxonomy,
	ProductTaxonomySearchRequest,
	ProductTaxonomySearchResponse,
	ProductTaxonomyCreateRequest,
	ProductTaxonomyUpdateRequest,
} from "brandguard/brandguard.product.detection_pb"

export function zero(d: Partial<ProductTaxonomy> = {}): ProductTaxonomy {
	return {
		id: "",
		account_id: "",
		brand_id: "",
		content_type: "",
		name: "",
		aliases: [],
		category: "",
		team_owner: "",
		created_at: "",
		updated_at: "",
		...d,
	}
}

export namespace searches {
	export function request(d: Partial<ProductTaxonomySearchRequest> = {}): ProductTaxonomySearchRequest {
		return {
			offset: 0n,
			brand_id: "",
			content_type: "",
			limit: 100n,
			category: "",
			...d,
		}
	}

	export function response(d: Partial<ProductTaxonomySearchResponse> = {}): ProductTaxonomySearchResponse {
		return {
			next: request(),
			items: [],
			...d,
		}
	}
}

export function search(
	req: ProductTaxonomySearchRequest,
	...options: httpx.option[]
): CancellablePromise<ProductTaxonomySearchResponse> {
	return httpx
		.get<ProductTaxonomySearchResponse>(`${httpx.urlstorage.host()}/bg/taxonomy/`, req, ...options)
		.then((r) => ({
			...r,
			items: (r.items || []).map(zero),
		}))
}

export function create(req: ProductTaxonomyCreateRequest, ...options: httpx.option[]): CancellablePromise<ProductTaxonomy> {
	return httpx.post<ProductTaxonomy>(`${httpx.urlstorage.host()}/bg/taxonomy/`, req, ...options).then(zero)
}

export function update(
	id: string,
	req: ProductTaxonomyUpdateRequest,
	...options: httpx.option[]
): CancellablePromise<ProductTaxonomy> {
	return httpx.put<ProductTaxonomy>(`${httpx.urlstorage.host()}/bg/taxonomy/${id}`, req, ...options).then(zero)
}

export function remove(id: string, ...options: httpx.option[]): CancellablePromise<void> {
	return httpx.destroy(`${httpx.urlstorage.host()}/bg/taxonomy/${id}`, {}, ...options)
}
